import { memo } from "react";
import { Typography, Grid2 } from "@mui/material";
import Popup from "../Popup.js";
import { ErrorBackgroundButton, SecondaryBorderButton } from "../Buttons.js";

const AreYouSurePopup = ({
    width = "700px",
    isOpen,
    title,
    titleColor = "black",
    onClose,
    innerText = "",
    declineText = "",
    onDecline,
    acceptText = "",
    onAccept,
}) => {

    return (
        <Popup
            width={width}
            open={isOpen}
            title={title}
            titleColor={titleColor}
            onClose={onClose}
        >
            <Typography component="div" sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                {innerText}
            </Typography>
            <Grid2
                width="100%"
                px={4}
                py={2}
                sx={{
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    fontSize: "1rem",
                    justifyContent: "flex-end",
                    display: "flex",
                    marginLeft: "auto",
                    marginBottom: "-2rem",
                }}
            >
                <SecondaryBorderButton title={declineText} backgroundColor="transparent" onClick={onDecline} />
                <div style={{ width: "30px" }} />
                <ErrorBackgroundButton title={acceptText} width={"300px"} onClick={onAccept} />
            </Grid2>
        </Popup>
    )
}

export default memo(AreYouSurePopup)
